import {
	BaseApiService,
	BaseDeleteDto,
	BaseFindDto,
	BaseFindOneDto,
	BaseUpdateDto,
	FindResponse
} from "@remar/shared/dist/api/baseApiService";

import { request } from "@remar/shared/dist/api/request";
import { LessonComment, LiveStream } from "@remar/shared/dist/models";

import { URLS } from "../services.constants";

export class LiveStreamService extends BaseApiService<
	LiveStream,
	Record<string, unknown>,
	BaseFindDto,
	BaseFindOneDto,
	BaseUpdateDto<Record<string, unknown>>,
	BaseDeleteDto
> {
	constructor(baseUrl: string) {
		super(baseUrl);
	}

	postComment(data: { comment: string; streamId: string }): Promise<unknown> {
		return request(
			`${this.baseUrl}/comment`,
			"POST",
			this.emptyStringToNull(data) as Record<string, unknown>
		) as Promise<unknown>;
	}

	fetchComments({
		streamId,
		options
	}: {
		streamId: string;
		options: Record<string, unknown>;
	}): Promise<FindResponse<LessonComment>> {
		return request(
			`${this.baseUrl}/comments/${streamId}${this.serializeQuery(options as Record<string, unknown>, {
				isTopLevel: true
			})}`,
			"GET"
		) as Promise<FindResponse<LessonComment>>;
	}
}

export const liveStreamService = new LiveStreamService(URLS.LIVE_STREAM);
